import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { Button, Card, Col, Container, Input, Row, Spinner } from "reactstrap";
import LargeSizeMomentos from "../../components/LargeSizeMomentos";
import SmallSizeMomento from "../../components/SmallSizeMomento";
import {
    getSingleMomento,
    updateMomento,
} from "../../store/actions/MomentosActions";
import { toast } from "react-toastify";

const EditMomento = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const history = useHistory();
    const { singleMomento, loading } = useSelector((state) => state.momentos);
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [updatedMomento, setUpdatedMomento] = useState();
    const [momentoAmount, setMomentoAmount] = useState();
    const [QRCodes, setQRCodes] = useState([]);
    const [mediaToRemove, setMediaToRemove] = useState([]);
    const [QRMediaRemove, setQRMediaRemove] = useState([]);

    useEffect(() => {
        if (id) {
            dispatch(getSingleMomento(id));
        }
    }, [id]);
    useEffect(() => {
        if (singleMomento) {
            setUpdatedMomento(singleMomento?.momento);
            setMomentoAmount(singleMomento?.momentoAmount);
            setTitle(singleMomento?.momentoTitle);
            setQRCodes(singleMomento?.qrCodes);
            setDescription(singleMomento?.momentoDescription);
        }
    }, [singleMomento]);

    const handleSubmit = (e) => {
        e.preventDefault();

        if (
            !title ||
            !description ||
            !momentoAmount ||
            updatedMomento.some((item) => item.title == "") ||
            updatedMomento.some((item) => item.subTitle == "") ||
            updatedMomento.some((item) => item.media == "")
        ) {
            toast.error("Please fill in all required fields.");
        } else {
            let payload = {
                ...singleMomento,
                momentoTitle: title,
                momentoDescription: description,
                momento: updatedMomento,
                momentoAmount: momentoAmount,
                qrCodes: QRCodes,
            };
            dispatch(
                updateMomento(
                    singleMomento.id,
                    payload,
                    // mediaToRemove,
                    // QRMediaRemove,
                    () => {
                        toast.success("Memento Updated Successfully");
                        setTitle("");
                        setDescription("");
                        setMomentoAmount();
                        // setMediaToRemove([]);
                        // setQRMediaRemove([]);
                        history.push("/main/mementos");
                    }
                )
            );
        }
    };

    return (
        <>
            <Container fluid>
                <Row className="justify-content-center mx-4 py-3">
                    <h3>Update Memento</h3>
                </Row>
                <Container>
                    <Card className=" p-4 create_momento-card">
                        <Row className="d-flex flex-column justify-content-center align-items-center p-2">
                            <Col lg={10} md={10} sm={10}>
                                <Row className="d-flex justify-content-center justify-content-lg-between align-items-center p-2">
                                    <Col
                                        lg={4}
                                        sm={10}
                                        className="mb-3 mb-lg-0"
                                    >
                                        <Input
                                            placeholder="Enter Memento Title"
                                            type="text"
                                            value={title}
                                            onChange={(e) =>
                                                setTitle(e.target.value)
                                            }
                                        />
                                    </Col>
                                    <Col lg={4} sm={10}>
                                        <Input
                                            type="text"
                                            placeholder="Enter Memento Description"
                                            value={description}
                                            onChange={(e) =>
                                                setDescription(e.target.value)
                                            }
                                        />
                                    </Col>
                                    <Col lg={4} sm={10}>
                                        <Input
                                            type="number"
                                            min={1}
                                            placeholder="Enter Memento Amount"
                                            value={momentoAmount}
                                            onChange={(e) =>
                                                setDescription(e.target.value)
                                            }
                                        />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        {singleMomento?.momentoSize == 14 ? (
                            <LargeSizeMomentos
                                momento={updatedMomento}
                                setMomento={setUpdatedMomento}
                                QRCODES={QRCodes}
                                setQRCODES={setQRCodes}
                                setMediaToRemove={setMediaToRemove}
                                setQRMediaRemove={setQRMediaRemove}
                            />
                        ) : (
                            <SmallSizeMomento
                                momento={updatedMomento}
                                setMomento={setUpdatedMomento}
                                QRCODES={QRCodes}
                                setQRCODES={setQRCodes}
                                setMediaToRemove={setMediaToRemove}
                                setQRMediaRemove={setQRMediaRemove}
                            />
                        )}
                    </Card>
                    <Row className="d-flex justify-content-center my-4">
                        <Button
                            color="warning"
                            className="text-white"
                            onClick={handleSubmit}
                        >
                            {loading ? (
                                <Spinner size="sm" className="mx-5" />
                            ) : (
                                "Update Memento"
                            )}
                        </Button>
                    </Row>
                </Container>
            </Container>
        </>
    );
};

export default EditMomento;
